import { useMemo, useContext } from "react";
import BryntumContext from "@/react/context/bryntumContext";
import { User } from "@/bryntum-lib/models/User";

type TGrant = {
  label: string;
  value: number;
};

export const useChecklistPermissions = () => {
  const { project, swivuAppGrants } = useContext(BryntumContext);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const projectTyped = project as any;

  // Get board users for assigned users dropdown
  const boardUsers = useMemo(() => {
    if (!projectTyped) return [];
    return projectTyped.boardUsersStore
      .query(() => true)
      .map((user: User) => ({
        label: user.name,
        value: String(user.id)
      }));
  }, [projectTyped]);

  return {
    boardUsers,
    grants: swivuAppGrants as TGrant[]
  };
};
